import React from 'react'
import useAppContext from '../../hook/useAppContext'
import './banner.css'

const Banner = () => {

      const {user, data} = useAppContext()
      const {banners} = user 

      const banner_img = banners.code ? data.banner.image : banners[0].url 
      const banner_title = banners.code ? data.banner.title : banners[0].title 

      return (
            <div className="banner_content">
                  <div className="banner_content__img flex">
                        <img src={banner_img} alt={banner_title} />
                  </div>
            </div>
      )
}

export default Banner
